import { render, staticRenderFns } from "./CreateOpenAward.vue?vue&type=template&id=e0a54db8&scoped=true&"
import script from "./CreateOpenAward.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateOpenAward.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateOpenAward.vue?vue&type=style&index=0&id=e0a54db8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a54db8",
  null
  
)

export default component.exports